import * as React from 'react';

export const VoidedIcon = () => {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{'498706F8-783F-4FF3-BBAD-19469DB2C3DE@1x'}</title>
      <path
        d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zM11.404 9.99L16 14.586l4.596-4.596a.5.5 0 01.707 0l.707.707a.5.5 0 010 .707L17.414 16l4.596 4.596a.5.5 0 010 .707l-.707.707a.5.5 0 01-.707 0L16 17.414l-4.596 4.596a.5.5 0 01-.707 0l-.707-.707a.5.5 0 010-.707L14.586 16 9.99 11.404a.5.5 0 010-.707l.707-.707a.5.5 0 01.707 0z"
        fill="#317D4F"
        fillRule="evenodd"
      />
    </svg>
  );
};
